var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CDCheckbox',{attrs:{"name":"newsletterSubscribe","color":"primary","checked":_vm.agree,"label":_vm.$t('companyRegistration.formSubscribeNewsletter')},on:{"change":_vm.toggleNewsletterSubscribe}})
}
var staticRenderFns = []

export { render, staticRenderFns }